import { ApiRequest } from './requests';
import { AssistUserSettingsBM } from '../models/settings/assist-user-settings.model';

export function getUserSettings(): ApiRequest<void, AssistUserSettingsBM> {
  return {
    url: '/api/users/me/settings',
    method: 'get',
  };
}

export function setUserSettings(settings: AssistUserSettingsBM): ApiRequest<AssistUserSettingsBM, void> {
  return {
    url: '/api/users/me/settings',
    method: 'post',
    payload: settings,
  };
}

export function getReservationFilters(): ApiRequest<
  void,
  {
    state: number[];
    showCanceled: boolean;
  }
> {
  return {
    url: '/api/users/me/filters',
    method: 'get',
  };
}

export function setReservationFilters(
  state: number[],
  showCanceled: boolean
): ApiRequest<
  {
    state: number[];
    showCanceled: boolean;
  },
  void
> {
  return {
    url: '/api/users/me/filters',
    method: 'post',
    payload: {
      state: state,
      showCanceled: showCanceled,
    },
  };
}
